import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SITE } from "../../constants";

export function WhatsAppIcon({ className = "h-7 w-7" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.964 9.964 0 0 0 1.333 4.993L2 22l5.233-1.237a9.994 9.994 0 0 0 4.779 1.217h.004c5.505 0 9.988-4.478 9.989-9.984 0-2.669-1.037-5.176-2.925-7.062A9.925 9.925 0 0 0 12.012 2zm0 18.157h-.003a8.318 8.318 0 0 1-4.238-1.161l-.304-.18-3.116.738.74-3.078-.198-.315a8.272 8.272 0 0 1-1.267-4.175c0-4.577 3.724-8.301 8.306-8.301a8.256 8.256 0 0 1 5.867 2.433 8.25 8.25 0 0 1 2.43 5.869c0 4.578-3.724 8.302-8.305 8.302zm4.551-6.216c-.249-.125-1.472-.726-1.7-.809-.228-.083-.394-.125-.56.125-.166.249-.644.809-.789.975-.145.166-.29.187-.539.062-.249-.125-1.05-.387-2-1.234-.738-.658-1.237-1.471-1.382-1.72-.145-.249-.015-.384.11-.508.112-.112.249-.29.373-.435.125-.145.166-.249.249-.415.083-.166.042-.311-.021-.435-.062-.125-.56-1.349-.768-1.847-.203-.484-.409-.418-.56-.426l-.477-.009c-.166 0-.435.062-.663.311-.228.249-.871.851-.871 2.075 0 1.224.892 2.406 1.016 2.572.125.166 1.754 2.678 4.249 3.755.594.256 1.058.409 1.42.524.597.19 1.14.163 1.569.099.479-.071 1.472-.601 1.68-1.182.207-.581.207-1.079.145-1.183-.062-.104-.228-.166-.477-.291z" />
    </svg>
  );
}

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);
  const number = SITE.whatsapp.replace(/[^0-9]/g, "");
  const href = `https://wa.me/${number}?text=${encodeURIComponent(
    "Hi Crescet Edustreams, I have a question about admissions, counselling, and tutoring."
  )}`;

  return (
    <div
      className="fixed bottom-6 left-6 z-50 flex items-center gap-3"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Original Circular Button with Breathing Green Glow Effect */}
      <motion.a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.92 }}
        className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white transition-all duration-300 hover:bg-[#20bd5a]"
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-fab"
      >
        {/* Continuous Breathing Ambient Glow Aura */}
        <motion.span
          animate={{
            boxShadow: [
              "0 0 16px 3px rgba(37, 211, 102, 0.45)",
              "0 0 32px 8px rgba(37, 211, 102, 0.8)",
              "0 0 16px 3px rgba(37, 211, 102, 0.45)",
            ],
          }}
          transition={{
            duration: 2.2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="absolute inset-0 rounded-full pointer-events-none"
        />

        {/* Outer Glow Halo Layer */}
        <span className="absolute -inset-1 rounded-full bg-[#25D366]/40 blur-md pointer-events-none transition-opacity duration-300 group-hover:bg-[#25D366]/60 group-hover:blur-lg" />

        {/* Official WhatsApp Logo */}
        <WhatsAppIcon className="relative z-10 h-8 w-8 transition-transform duration-300 group-hover:scale-110" />
      </motion.a>

      {/* Interactive Tooltip Card on Hover */}
      <AnimatePresence>
        {hovered && (
          <motion.div
            initial={{ opacity: 0, x: -10, scale: 0.95 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: -10, scale: 0.95 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="hidden sm:flex flex-col rounded-2xl border border-black/5 bg-white/95 px-4 py-2.5 shadow-xl shadow-black/10 backdrop-blur-xl pointer-events-none"
          >
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-[#25D366]" />
              <p className="text-xs font-bold text-[#063B30]">Chat on WhatsApp</p>
            </div>
            <p className="text-[11px] font-medium text-gray-500">
              Instant reply for students & parents
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
